
export const ANNUAL_LEAVE_ID = 1
export const SICK_ID = 2
export const PERSONAL_LEAVE_ID = 3
export const PUBLIC_HOLIDAYS_ID = 4
export const REMOTE_WORK_ID = 5

export const EVENT_CATEGORY = [
  {
    id: ANNUAL_LEAVE_ID,
    isActive: false,
    name: 'Annual leave',
    color: '#0D7BC4',
    class: 'vacation'
  },
  {
    id: SICK_ID,
    isActive: false,
    color: '#FF7B1C',
    name: 'Sick',
    class: 'sick'
  },
  {
    id: PERSONAL_LEAVE_ID,
    isActive: false,
    color: '#FFB341',
    name: 'Personal leave',
    class: 'personal'
  },
  {
    id: PUBLIC_HOLIDAYS_ID,
    isActive: false,
    color: '#643EFF',
    name: 'Public holidays',
    class: 'public'
  },
  {
    id: REMOTE_WORK_ID,
    isActive: false,
    color: '#04AB14',
    name: 'Remote work',
    class: 'remote'
  }
]



// WEBPACK FOOTER //
// ./src/constants/eventCategory.js